import React, { ReactElement } from 'react';
import { Component, Container, PuzzleCheckbox } from "puzzle"
import _ from 'lodash';
import { CHECKBOX_JOB } from "./Types";

export type PROPS = {
  activeTabLanguages: boolean
  checkboxes: CHECKBOX_JOB[]
  startIndex: number,
  onCheckChange: Function
};

class PreviewDeliverablesSubmissionSection extends Component<PROPS> {

  languageMap = new Map();
  batchMap = new Map();

  moduleDidMount = () => {
    this.addJobsToMaps();
    this.forceUpdate();
  };

  /**
   * Initially maps all jobs
   * Both language and batch maps have for
   *  key: language(batch)-name, and for
   *  value: array of jobIndexes in parent's state
   */
  addJobsToMaps = () => {
    const { checkboxes: jobs } = this.props;
    jobs.forEach((job: CHECKBOX_JOB) => {
      this.addToMap(this.languageMap, job.targetLocale, job.jobIndex);
      this.addToMap(this.batchMap, job.batchName, job.jobIndex);
    });
  };

  /**
   * For given map and key, it pushes jobIndex from parent's state to an existing (or creates new) array of jobIndexes
   * @param map
   * @param key
   * @param value
   */
  addToMap = (map: Map<string, number[]>, key: string, value: number) => {
    const oldMapValue = map.get(key);
    if (_.isEmpty(oldMapValue)) {
      map.set(key, [value]);
    } else {
      map.set(key, [...oldMapValue, value]);
    }
  };

  /**
   * Checkbox renderer for a single job
   * @param checkboxNameProperty
   * @param indexInParentsState
   */
  renderCheckboxJob = (checkboxNameProperty: string, indexInParentsState: number) => {
    const { checkboxes, startIndex } = this.props;
    const checkbox = checkboxes[indexInParentsState - startIndex];
    return (
      <span
        className={'tp-submission-job'}
        key={checkboxNameProperty + indexInParentsState}
      >
        <PuzzleCheckbox
          className={`k-hbox k-align-items-center ${checkbox.checked ? 'qa-fakeClass-checked' : ''}`}
          onChange={this.props.onCheckChange.bind(this, indexInParentsState)}
          checked={checkbox.checked}
          label={(checkbox as any)[checkboxNameProperty]}
        />
      </span>)
  };

  /**
   * Returns true if all group is checked, false otherwise
   * @param checkboxGroup
   */
  isGroupChecked = (checkboxGroup: number[]) => {
    const { checkboxes, startIndex } = this.props;
    return checkboxGroup.every(index => checkboxes[index - startIndex].checked);
  };

  /**
   * CheckboxGroup renderer
   * @param groupName
   * @param checkboxGroup
   * @param checkboxNameProperty
   */
  renderCheckboxGroupOfJobs = (groupName: string, checkboxGroup: number[], checkboxNameProperty: string) => {
    return (
      <Container role="row" key={groupName} className='tp-submission-job-group'>
        <Container role="gridcell" className={'tp-job-group pd-grid-cell'}>
          <PuzzleCheckbox
            className={`k-hbox k-align-items-center tp-job-checkbox ${this.isGroupChecked(checkboxGroup) ? 'qa-fakeClass-checked' : ''}`}
            onChange={this.props.onCheckChange.bind(this, checkboxGroup)}
            checked={this.isGroupChecked(checkboxGroup)}
            label={this.translate('groupLabel', { groupName: groupName })}
          />
        </Container>
        <Container role="gridcell" className={'pd-grid-cell tp-submission-jobs-wrap'}>
          {checkboxGroup.map(this.renderCheckboxJob.bind(this, checkboxNameProperty))}
        </Container>
      </Container>
    )
  };

  renderBody = () => {
    const { checkboxes, activeTabLanguages } = this.props;
    let contentList: ReactElement[] = [], checkboxGroup, activeMap = this.languageMap,
      checkboxNameProperty = 'batchName';
    if (!activeTabLanguages) {
      activeMap = this.batchMap;
      checkboxNameProperty = 'targetLocale';
    }
    const groups = activeMap.keys();
    for (let groupName of groups) {
      checkboxGroup = activeMap.get(groupName);
      contentList.push(this.renderCheckboxGroupOfJobs(groupName, checkboxGroup, checkboxNameProperty))
    }
    return (!!checkboxes.length && contentList)
  };
}

export default PreviewDeliverablesSubmissionSection;
